import React, { Component } from 'react'
import { checkTranslation, imageAddress } from '../../../../utils/useful';
import CircularProgress from "../../../useful/CircularProgress";
import MessageStatusView from './MessageStatusView';


class MessageImageBox extends Component {


    render() {
        let data = this.props.data
        let address = ''
        if (data?.image) {
            address = imageAddress(data.image, null, 'small')
            // console.log('data.immage', address)
        } else if (data.tempFile) {

            if (this.state?.address) {
                address = this.state.address
            } else {
                address = URL.createObjectURL(data.tempFile)
                this.setState({ address })
            }

        }
        // console.log(data)
        return (
            <div style={{ width: 250 }} className={'w-100 d-flex flex-column ' + (this.props.isOtherRef ? 'justify-content-start align-items-start' : 'justify-content-end align-items-end')}>
                <div className={" " + (this.props.isOtherRef ? 'chatbox-other' : 'chatbox')} style={{ width: 250, paddingBottom: "5px" }}>
                    <div style={{ padding: "5px", }}>
                        <div style={{ overflow: "hidden", position: "relative", display: "flex", alignItems: "center", justifyContent: "center" }} onClick={() => this.props.openImageModal(address)} >

                            {(data.tempFile) && (
                                <div className='flexcc ' style={{ padding: 2, border: '0px solid #eee', boxShadow: '0px 0px 30px #10101040', backgroundColor: 'rgb(3 25 45)', borderRadius: 80, position: "absolute", zIndex: 1, }}>
                                    <CircularProgress size={34} strokeWidth={3} progress={data.precentage} />
                                </div>
                            )}

                            <img className='w-100' onClick={() => this.props.openImageModal()} src={address} style={{ objectFit: "contain", borderRadius: 10 }} alt='' />
                        </div>

                        {/* {data.text
                         */}
                    </div>
                    {data.text && (
                        <div className={"d-flex " + (this.props.isOtherRef ? 'captionbox-other' : 'captionbox')} style={{ maxWidth: 350, padding: '10px 10px', marginLeft: "5px", marginRight: "5px" }}>
                            <p className={"mt-1 " + (this.props.isOtherRef ? '' : ' ')} style={{ color: "#333" }}>{checkTranslation(data.text)}</p>
                        </div>
                    )}
                </div>
                <div className={"w-100 d-flex mt-1 " + (this.props.isOtherRef ? 'justify-content-start align-items-start' : 'justify-content-end align-items-end')}>
                    <div className="flexc">

                        {(this.props.showSelfSenderInfo && !this.props.isOtherRef && this.props.chatInteractive) && (
                            <div className="d-flex w-100 mrd-1">
                                <p className="font-size-10   w-100" style={{ color: '#000000aa', textOverflow: 'ellipsis', overflow: 'hidden', }}>{this.props.chatInteractive[data.sender]?.hub?.fullname} - </p>
                            </div>
                        )}

                        <p className='mrd-2' style={{ color: "gray", fontSize: 10 }}>{checkTranslation(this.props.time)}</p>

                        {!this.props.isOtherRef && (
                            <MessageStatusView status={data.status} colors={this.props.colors} />
                        )}


                        {(this.props.showSelfSenderInfo && this.props.isOtherRef && this.props.chatInteractive) && (
                            <div className="d-flex w-100 mrd-1">
                                <p className="font-size-10   w-100" style={{ color: '#000000aa', textOverflow: 'ellipsis', overflow: 'hidden', }}> - {this.props.chatInteractive[data.sender]?.hub?.fullname}</p>
                            </div>
                        )}
                    </div>
                </div>
            </div >

        )
    }
}

export default MessageImageBox;